export default (roundId, teamId) => (teamId ? `${teamId}@${roundId}` : null)
